import { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";

// Upload a replacement PDF as a NEW draft revision; the issued PDF and its signatures are preserved.
export function WsReplacePdf({ rid, onClose, onDone }) {
  const [file, setFile] = useState(null);
  const [summary, setSummary] = useState("");
  const [fresh, setFresh] = useState(true);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (busy) return; setBusy(true);
    const fd = new FormData();
    fd.append("file", file); fd.append("change_summary", summary); fd.append("requires_fresh_ack", fresh ? "true" : "false");
    try { await api.post(`/policies/${rid}/revisions/pdf`, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("New PDF draft created — review and publish"); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Upload failed"); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="ws-replace-pdf">
        <DialogHeader><DialogTitle>Replace PDF</DialogTitle>
          <DialogDescription>Creates a new draft revision. The issued PDF and everyone's signatures are kept in history.</DialogDescription></DialogHeader>
        <input data-testid="ws-replace-pdf-file" type="file" accept=".pdf,application/pdf" onChange={(e) => setFile(e.target.files?.[0] || null)} className="text-sm" />
        <Textarea data-testid="ws-replace-pdf-summary" value={summary} onChange={(e) => setSummary(e.target.value)} placeholder="Why is it being replaced? (required)" className="min-h-[60px]" />
        <label className="flex items-start gap-2 text-sm"><input type="checkbox" data-testid="ws-replace-pdf-fresh" checked={fresh} onChange={(e) => setFresh(e.target.checked)} className="mt-1" />
          <span>Material change — require fresh acknowledgement (you can still change this when publishing).</span></label>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button data-testid="ws-replace-pdf-submit" disabled={busy || !file || !summary.trim()} onClick={submit} className="bg-emerald-700 hover:bg-emerald-800">{busy ? "Uploading…" : "Upload as draft"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
